module.exports = __webpack_public_path__ + "img/BOWTIE 2 RED.bba01d2.svg";